import React from "react";
import DonateBanner from "./DonateBanner";
import DonateForm from "./DonateForm";
import SEO from "../SEO";
import { useEffect } from "react";
import ReactGA  from "react-ga4";
const Donate = () => {
	useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/donate",
      title: "Donate | SynergyCare Foundation",
    });
  });
	return (
		<div className=''>
			<SEO
				title='Donate | SynergyCare Foundation'
				description='Donate generously to SynergyCare Foundation’'
				name='SynergyCare Foundation'
				type=''
			/>
			<DonateBanner />
			<DonateForm />
		</div>
	);
};

export default Donate;
